import React, { useState } from "react";
import LandingPageLayout from "../../shared/Layouts/LandingPageLayout";

import { Fade } from "react-awesome-reveal";
import { faqData } from "../../constants";
import { FAQ_BTN } from "../../assets";
import clsx from "clsx";
import Contact from "../landingPage/contact";

const options = [
  {
    label: "User Accounts & Portal Access",
    value: "User Accounts",
  },
  {
    label: "Filing & Case Management",
    value: "Application Requirements",
  },
  {
    label: "Cause Lists & Judgments",
    value: "Submission & Processing",
  },
  {
    label: "Payments & Receipts",
    value: "Payments & Receipts",
  },
  {
    label: "Court Procedures & Guidelines",
    value: "Document Guidelines",
  },
  {
    label: "Notifications & Updates",
    value: "Notifications & Updates",
  },
];
function FAQs() {
  const [openedFaq, setOpenedFaq] = useState(0);
  const [selectedFaqType, setSelectedFaqType] = useState("User Accounts");

  //   const filteredFqas = faqs.filter((item) => item.type === selectedFaqType);
  return (
    <LandingPageLayout title={<>FAQ</>} currentLink={"FAQ"}>
      <div className="mt-8 sm:mt-10 px-4 sm:px-6 lg:px-[10rem] overflow-x-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-5 justify-center items-center min-w-max lg:min-w-0">
          {options.map((item, index) => (
            <div
              key={index}
              onClick={() =>
                // @ts-ignore
                setSelectedFaqType(item.value)
              }
              className={`min-w-full cursor-pointer h-[45px] sm:h-[50px] hover:border-b-2 hover:border-b-globalGreen ${
                selectedFaqType === item.value &&
                " border-b-2 border-b-globalGreen"
              } transition-all duration-300 rounded-b-xl shadow-container justify-center rounded-xl flex items-center px-3 sm:px-5`}
            >
              <span
                className={clsx(
                  "text-sm sm:text-[16px] font-semibold text-center leading-relaxed",
                  selectedFaqType === item.value
                    ? "text-globalGreen"
                    : "text-primary-300"
                )}
              >
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center justify-center px-4 sm:px-6 lg:px-[15rem] py-8 sm:py-12 lg:py-20">
        <div className="w-full flex flex-col gap-y-3 sm:gap-y-4">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="w-full flex flex-col gap-y-3 sm:gap-y-4 shadow-container bg-white rounded-lg p-3 sm:p-4"
            >
              <div className="flex items-center justify-between w-full">
                <span className="text-sm sm:text-base lg:text-[16px] font-medium text-primary-300 leading-relaxed pr-2">
                  {index + 1}. {item.question}
                </span>

                <img
                  src={FAQ_BTN}
                  className={`w-[28px] sm:w-[32px] h-[28px] sm:h-[32px] cursor-pointer flex-shrink-0 ${
                    openedFaq === index ? "rotate-360" : "rotate-180"
                  } transition-all duration-300`}
                  onClick={() => {
                    openedFaq === index ? setOpenedFaq(0) : setOpenedFaq(index);
                  }}
                  alt="Toggle FAQ"
                />
              </div>
              {openedFaq === index && (
                <Fade
                  direction="down"
                  duration={1000}
                  className="text-xs sm:text-sm lg:text-sm font-medium text-[#555555] leading-relaxed"
                >
                  {faqData[0].answer}
                </Fade>
              )}
            </div>
          ))}
        </div>
      </div>
      <Contact />
    </LandingPageLayout>
  );
}

export default FAQs;
